import React from 'react';
import cx from 'classnames';
import s from './Stack.scss';

enum SpaceSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
}
interface StackProps {
  children: React.ReactNode;
  forceColumn?: boolean;
  space?: string;
  responsive?: boolean;
}

interface StackItemProps {
  children: React.ReactNode;
  cell?: string;
}

const Item = ({ children, cell }: StackItemProps) => {
  return (
    <div className={s.stackItem} style={{ flex: cell }}>
      {children}
    </div>
  );
};

const Stack = ({ children, forceColumn, space, responsive }: StackProps) => {
  const classNames = cx(
    s.stack,
    space && s[`space-${space}`],
    forceColumn && s.column,
    responsive ? s.responsive : s.viewport,
  );
  return <div className={classNames}>{children}</div>;
};

Stack.Item = Item;
Stack.SpaceSize = SpaceSize;

export default Stack;
